import {MatPaginatorIntl} from '@angular/material/paginator';
import {Injectable} from '@angular/core';

// @Component({
//   selector: 'app-custom-mat-paginator-intl',
//   templateUrl: './custom-mat-paginator-intl.component.html',
//   styleUrls: ['./custom-mat-paginator-intl.component.scss']
// })
// export class CustomMatPaginatorIntlComponent implements OnInit {

//   constructor() { }

//   ngOnInit(): void {
//   }

// }



@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  constructor() {
    super();

    this.getAndInitTranslations();
  }

  getAndInitTranslations() {

      this.itemsPerPageLabel = "Items por página:";
      this.nextPageLabel = "Siguiente";
      this.previousPageLabel = "Anterior";
      this.changes.next();

  }

 getRangeLabel = (page: number, pageSize: number, length: number) =>  {
    if (length === 0 || pageSize === 0) {
      return `0 de ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `Mostrando ${startIndex + 1} - ${endIndex} de ${length} resultados`;
  }
}
